import {Case} from './case.model';
import {Card} from './card.model';
import {Error} from './error.model';

export class Data {
  cases: Case[];
  cards: Card[];
  error: Error;
  systemTime: number;

  constructor(cards: Card[], cases: Case[]) {
    this.cards = cards;
    this.cases = cases;
  }
}
